<template>
	<div>
		<div class="d-flex justify-content-center py-4" v-if="isLoading">
			<loader/>
		</div>
		<notification-message
			message="Parece que aún no agregas soluciones"
			v-if="services=='' && !this.isLoading && this.solutionSelected"
		/>
		<div class="main-content-container container-fluid px-4">


      <div class="page-header row no-gutters py-4" v-if="!isLoading">
        <div class="col-12 col-sm-4 text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">Servicios</span>
          <h3 class="page-title">Visión general</h3>
        </div>
        <div class="col-12 col-sm-4">
        </div>
        <div class="col-12 col-sm-4 d-flex align-items-center">
          <select class="form-control" @change="serviceSelected">
          	<option value="" default>Selecciona una solución</option>
          	<option v-for="(solution, index) in solutions" :key="index" :value="solution.id">
          		{{ solution.name }}
          	</option>
          </select>
        </div>
      </div>

			<div class="row">
        <div class="col-lg-3 col-md-6 col-sm-12 mb-4" v-for="(service, index) in services" :key="index" v-if="!isLoading">
          <div class="card card-small card-post card-post--1">
						<div class="card-header border-bottom text-dark font-weight-bold text-uppercase text-left">
							{{ service.name }}
							<span href="#" class="card-post__category badge badge-pill badge-light">
								{{ service.solution }}
							</span>
						</div>
            <div class="card-post__image text-center">
            	<img :src="service.icon" class="img-fluid"/>
            </div>
						<div class="card-footer border-top text-primary">
							<span class="badge badge-secondary mr-2" @click.prevent="deleteOption(service.id, index)">
								<i class="fas fa-trash"/>
							</span>
							<router-link :to="'/servicio/' + service.slug" class="badge badge-secondary">
								<i class="fas fa-edit"></i>
							</router-link>
						</div>
          </div>
        </div>
			</div>
		</div>
	</div>
</template>

<script>
	import NotificationMessage from '@/components/general/NotificationMessage';
	import axios from 'axios'
	export default {
		components: {
			NotificationMessage
		},
		data() {
			return {
				isLoading: true,
				solutions: [],
				solutionSelected: '',
				services: [],
			}
		},

		mounted() { 	
			this.getSolutionsList();
			/*this.getServices();*/
		},

		methods: {
			async getSolutionsList() {
				let url = process.env.VUE_APP_ROOT_API.concat('/solution/list');
				let response = await fetch(url);
				if(response.status == 200) {
					this.isLoading = false;
					this.solutions = await response.json();
				}
			},

			serviceSelected(e) {
				this.getServices(e.target.value);
			},

			async getServices(id) {
				this.isLoading = true;
				let url = process.env.VUE_APP_ROOT_API.concat(`/service/list/${id}`);
				let response = await fetch(url);
				if(response.status == 200) {
					this.isLoading = false;
					this.services = await response.json();
				}
			},

			deleteOption(id, index) {
				const message = '¿Quieres eliminar este servicio?';
				const options = {
					okText: 'Sí',
					cancelText: 'No'
				};
				let that = this;
				this.$dialog
					.confirm(message, options)
					.then(function(dialog) {
						that.deleteService(id, index);
					});
			},

			async deleteService(id, index) {
				const url = `${process.env.VUE_APP_ROOT_API}/service/${id}`;
				const settings = {
					method: 'DELETE'
				};
				const response = await fetch(url, settings);
					if(response.status == 200) {
					this.services.splice(index, 1);
				}
			}
		}
	}
</script>